/**
 * @file: 控制聊天请求的变量，用于管理请求链路
 * @author: chenyingliao <chenyingliao@baidu.com>
 * @Date: 2023-12-12 17:57:16
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-04-08 15:36:53
 * @FilePath: /console-znzs/src/utils/chatHook.js
 */
import Vue from 'vue';
import {userSubmitQuestion} from '@/znzs/src/api/robot.js';
import {PLATFORM_KEY} from '@/znzs/src/constants';
import {DIALOG_TYPE, DISPLAY_TYPE} from '@/znzs/src/utils/enum';
import {handleAfterUserAction, pushMessage} from './chat';

/**
 * 默认机器人回复的处理方式
 */
async function defautlRebotReplayAction(data) {
    const {show, turnManual = false, knowledgeId = '', dialogInfo = {}} = data;

    /**
     * 对于机器人的回复需要校验其是否能在当前平台显示
     * * @description https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/pKzJfZczuc/v3byE0p5qJ/e141074f353543#anchor-41d786d0-ad0c-11ed-a73e-05753aa4e5cc
     */
    if ((show & PLATFORM_KEY) === PLATFORM_KEY) {
        handleAfterUserAction(data);
    }
    /*
        每个机器人回复中都携带 turnManual 字段，如果为 true，则交互达到阈值，机器人需要回复转人工话术，目前为前端构造
        https://yapi.baidu-int.com/project/18492/interface/api/951496
    */
    if (turnManual) {
        // 手动推出转工单的卡片
        pushMessage(DIALOG_TYPE.INTERACTIVE, DISPLAY_TYPE.TO_TS);
    }
}

const rebotReplayActionMap = {
    /**
     * 自助退款工具
     */
    [DISPLAY_TYPE.REFUND_TOOL](data) {
        Vue.prototype.$trackBehavior({
            name: '触发退款自助工具',
        });
        defautlRebotReplayAction(data);
    },
    /**
     * 自助升降配工具
     */
    [DISPLAY_TYPE.CONFIG_CHANGE_TOOL](data) {
        Vue.prototype.$trackBehavior({
            name: '触发升降配自助工具',
        });
        defautlRebotReplayAction(data);
    },
    /**
     * SMS审核管理工具
     */
    [DISPLAY_TYPE.SMS_TOOL](data) {
        Vue.prototype.$trackBehavior({
            name: '触发SMS审核进度查询自助工具',
        });
        defautlRebotReplayAction(data);
    },
    /**
     * 文心回答
     * @param {*} data
     */
    [DISPLAY_TYPE.ERNIE_BOT](data) {
        defautlRebotReplayAction(data);
    },
    default: defautlRebotReplayAction,
};


class MessageHook {
    constructor() {
        this.before = [];
        // 可以随时修复请求的实例
        // instance实例方法的要求是返回一个Promise，以此控制文心loading的显示
        this.instance = this.defaultInstance;
        this.actionMap = {...rebotReplayActionMap};
        this.after = [];
    }

    // 给返回的类型注册自定义处理函数
    registerAction(actionName, action) {
        this.actionMap[actionName] = action;
    }
    // 对外暴露的实际请求方法
    async requestInstance(...params) {
        try {
            const data = await this.instance(...params);
            return data;
        }
        finally {
            // 重置请求实例
            if (this.instance !== this.defaultInstance) {
                this.instance = this.defaultInstance;
            }
        }
    }

    /**
     * 拿到消息对象后的处理方法
     * @param {*} data
     */
    async postMessageData(data) {
        if (this.actionMap[data.dialogInfo?.display]) {
            await this.actionMap[data.dialogInfo?.display](data);
        }
        else {
            await this.actionMap.default(data);
        }
        this.sendAfter();
        return data;
    }

    // 默认请求，走机器人回复question接口
    async defaultInstance(...args) {
        const {data = {}} = await userSubmitQuestion(...args);
        await this.postMessageData(data);
        return data;
    }

    async sendBefore() {
        if (this.before.length) {
            const tasks = this.before.reduce((prev, next) => {
                return prev.then(next);
            }, Promise.resolve());
            this.before = [];
            return await tasks;
        }
    }

    async sendAfter() {
        if (this.after.length) {
            const tasks = this.after.reduce((prev, next) => {
                return prev.then(next);
            }, Promise.resolve());
            this.after = [];
            return await tasks;
        }
    }
}

export default new MessageHook();